// src/utils/tracking/trackEvent.js
// Funció genèrica per enviar events d'activitat al backend

export async function trackEvent(type, metadata = {}) {
  const apiUrl = process.env.REACT_APP_API_URL || 'http://localhost:5001/api';
  const token = localStorage.getItem('token');

  try {
    const res = await fetch(`${apiUrl}/activity/track`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        ...(token ? { Authorization: `Bearer ${token}` } : {})
      },
      body: JSON.stringify({ type, metadata })
    });

    if (!res.ok) {
      console.error(`❌ Error tracking event: ${res.statusText}`);
    }
  } catch (err) {
    console.error('❌ Error sending tracking event:', err);
  }
}
